<script>
import RawData from "@/components/widgets/raw-data.vue";
import InventoryCardList from "./inventory-card-list.vue";

export default {
    props: {
        itemData: {
            type: Object,
            default: null,
        },
        assignmentHistoryEmployeeData: {
            type: Array,
            default: () => [],
        },
        assignmentHistoryLocationData: {
            type: Array,
            default: () => [],
        },
        viewFrom: {
            type: String,
            default: "supply",
        },
    },
    components: {
        RawData,
        InventoryCardList,
    },
    data() {
        return {
            checkedToggleList: [],
            propertyFields: [
                {
                    key: "Name",
                    sortable: true,
                    label: "Property",
                },
            ],
            sortBy: "id",
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
        };
    },
    computed: {
        propertyFiltered() {
            if (this.itemData) {
                let data = this.itemData.inventoryItems;
                if (this.filterEmployeeId) {
                    data = data.filter((item) => {
                        return item.employeeIdNumber == this.filterEmployeeId;
                    });
                }
                if (this.itemData.filter.trim() != "" && this.itemData.filter) {
                    data = data.filter((item) => {
                        return item.filterKey.toUpperCase().includes(this.itemData.filter.toUpperCase());
                    });
                }
                return data;
            }
            return [];
        },
        propertyRows() {
            if (this.itemData) {
                if ((this.itemData.filter.trim() != "" && this.itemData.filter) || this.filterEmployeeId) {
                    return this.propertyFiltered.length;
                } else {
                    return this.itemData.inventoryItems.length;
                }
            }
            return 0;
        },
    },
    methods: {
        async changeAvailableness(accountableOfficer, event) {
            let payload = {
                id: this.itemData.id,
                empId: accountableOfficer.employeeIdNumber,
                isPresent: event.srcElement.checked
            }
            await this.$store.dispatch("propertyinventory/UpdatePresentInStation", payload)
                .then((res) => {
                    if (res.data.error) {
                        this.showToast(res.data.errorMessage, "error");
                        accountableOfficer.presentInStation = !event.srcElement.checked;
                        return;
                    }
                    this.showToast("Status updated successfully", "success");
                })
                .catch((error) => {
                    accountableOfficer.presentInStation = !event.srcElement.checked;
                    this.showToast("Something went wrong.", "error");
                });
        },
        checkToggle({ property, parent, checkEvent }) {
            if (checkEvent.srcElement.checked) {
                if (!this.checkedToggleList.find(prop => prop.id == property.id)) {
                    this.checkedToggleList.push({ id: property.id, propertyId: property.propertyId });
                }
                var count = 0;
                parent.properties.forEach((item) => {
                    if (item.toggleSelected === true) {
                        count++;
                    }
                });
                if (count == parent.properties.length) {
                    parent.toggleAll = true;
                } else {
                    parent.toggleAll = false;
                }
            } else {
                this.checkedToggleList = this.checkedToggleList.filter((item) => item.id !== property.id);
                parent.toggleAll = false;
            }
        },
        resetToggle(row) {
            row.toggleAll = false;
            row.inventoryItems.map((item) => {
                item.properties.map((prop) => {
                    prop.toggleSelected = false;
                });
            });
        },
        changePropertyStatus({ id, foundInStation }) {
            var inventoryItemIds = [];
            inventoryItemIds.push(id);
            this.$store
                .dispatch("propertyinventory/UpdateFoundInStation", { inventoryItemIds, foundInStation })
                .then((res) => {
                    if (res.data.error) {
                        this.showToast("Cannot update info. " + res.data.errorMessage, "error");
                        return;
                    }
                    this.showToast("Status updated successfully", "success");
                })
                .catch((error) => {
                    this.showToast("Something went wrong.", "error");
                });
        },
        changeBookedStatus({ id, booked }) {
            var inventoryItemIds = [];
            inventoryItemIds.push(id);
            this.$store
                .dispatch("propertyinventory/UpdateBookedStatus", { inventoryItemIds, booked })
                .then((res) => {
                    if (res.data.error) {
                        this.showToast("Cannot update info. " + res.data.errorMessage, "error");
                        return;
                    }
                    this.showToast("Status updated successfully", "success");
                })
                .catch((error) => {
                    this.showToast("Something went wrong.", "error");
                });
        },
        changeMultiplePropertyStatus(foundInStation) {
            var inventoryItemIds = this.checkedToggleList.map(prop => prop.id);
            this.$swal({
                title: "Are you sure?",
                text: `${inventoryItemIds.length} ${inventoryItemIds.length > 1 ? "properties" : "property"} selected.`,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, change it!",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("propertyinventory/UpdateFoundInStation", { inventoryItemIds, foundInStation })
                        .then((res) => {
                            if (res.data.error) {
                                this.showToast("Cannot update info. " + res.data.errorMessage, "error");
                                return;
                            }
                            this.itemData.inventoryItems.forEach((item) => {
                                item.properties.map(prop => {
                                    if (inventoryItemIds.includes(prop.id)) {
                                        prop.foundInStation = foundInStation;
                                    }
                                })
                            });
                            this.showToast("Status updated successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong.", "error");
                        });
                }
            });
        },
        changeMultipleBookedStatus(booked) {
            var inventoryItemIds = this.checkedToggleList.map(prop => prop.id);
            this.$swal({
                title: "Are you sure?",
                text: `${inventoryItemIds.length} ${inventoryItemIds.length > 1 ? "properties" : "property"} selected. `,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, change it!",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("propertyinventory/UpdateBookedStatus", { inventoryItemIds, booked })
                        .then((res) => {
                            if (res.data.error) {
                                this.showToast("Cannot update info. " + res.data.errorMessage, "error");
                                return;
                            }
                            this.itemData.inventoryItems.forEach((item) => {
                                item.properties.map(prop => {
                                    if (inventoryItemIds.includes(prop.id)) {
                                        prop.booked = booked;
                                    }
                                })
                            });
                            this.showToast("Status updated successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong.", "error");
                        });
                }
            });
        }
    }
}
</script>
<template>
    <div>
        <div class="d-flex justify-content-between mb-2">
            <div class="d-flex">
                <transition name="fade">
                    <transition name="slide">
                        <div v-if="checkedToggleList.length > 0" class="d-flex align-items-center mt-2">
                            <button type="button" class="btn btn-sm btn-purple d-flex align-items-center"
                                @click="$emit('printStickerMultiple', checkedToggleList)">
                                <i class="bx bx-printer fs-6 me-1"></i>Print Stickers
                            </button>
                            <b-dropdown id="dropdown-dropleft" right variant="link"
                                toggle-class="text-decoration-none p-0" menu-class="dropdown-menu-end" no-caret>
                                <template #button-content>
                                    <button type="button" class="btn btn-sm btn-info ms-1 d-flex align-items-center">
                                        <i class="bx bx-edit fs-6 me-1"></i>Update Selected
                                    </button>
                                </template>
                                <template v-if="viewFrom == 'supply'">
                                    <b-dropdown-item @click="$emit('changeCondition', checkedToggleList)"
                                        variant="info">
                                        <i class="mdi mdi-clipboard-edit-outline font-size-18 me-1"></i>Update Condition
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="$emit('changeNote', checkedToggleList)" variant="info">
                                        <i class="mdi mdi-file-document-edit-outline font-size-18 me-1"></i>Update
                                        Remark
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="$emit('changeItemCategory', checkedToggleList)"
                                        variant="info">
                                        <i class="mdi mdi-clipboard-edit-outline font-size-18 me-1"></i>Update Item
                                        Category
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="changeMultiplePropertyStatus(true)" variant="success">
                                        <i class="bx bx-check font-size-18 me-1"></i>Found in Station
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="changeMultiplePropertyStatus(false)" variant="danger">
                                        <i class="bx bx-x font-size-18 me-1"></i>Not Found in Station
                                    </b-dropdown-item>
                                </template>
                                <b-dropdown-item @click="changeMultipleBookedStatus(true)" variant="success">
                                    <i class="bx bx-check font-size-18 me-1"></i>Booked
                                </b-dropdown-item>
                                <b-dropdown-item @click="changeMultipleBookedStatus(false)" variant="danger">
                                    <i class="bx bx-x font-size-18 me-1"></i>Not Booked
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </transition>
                </transition>
            </div>
            <div class="d-flex">
                <div class="d-flex align-items-center float-end">
                    <button type="button" @click="$emit('selectFundCluster', 'rpcsp')"
                        class="btn btn-sm btn-purple d-flex align-items-center ms-1">
                        <i class="bx bx-printer fs-6 me-1"></i>Print RPCSP
                    </button>
                    <button type="button" @click="$emit('selectFundCluster', 'rpcppe')"
                        class="btn btn-sm btn-purple d-flex align-items-center ms-1">
                        <i class="bx bx-printer fs-6 me-1"></i>Print RPCPPE
                    </button>
                </div>
            </div>
        </div>
        <b-table class="propertyTable datatables target-table" :items="propertyFiltered" :fields="propertyFields"
            responsive="sm" :per-page="itemData.perPage" :current-page="itemData.currentPage" :sort-by="sortBy"
            :sort-desc="false" :busy="itemData.tableBusy" bordered show-empty>
            <template #empty>
                <b-card-header>
                    <div class="text-center">
                        <div v-if="itemData.filter != ''">
                            <i class="fas fa-exclamation-triangle me-2"></i>There
                            are no properties matching your request
                        </div>
                        <div v-else>
                            <i class="fas fa-exclamation-triangle me-2"></i>No
                            properties available
                        </div>
                    </div>
                </b-card-header>
            </template>
            <template #table-busy>
                <b-card-header>
                    <div class="d-flex justify-content-center align-items-center p-2">
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </b-card-header>
            </template>
            <template #cell(name)="accountableRow">
                <div class="position-relative ms-1">
                    <RawData :data="accountableRow.item" v-if="$store.state.decrypt.isAdmin()"
                        :keyId="accountableRow.item.employeeIdNumber" :exclude="['properties']" />
                </div>
                <div class="py-2">
                    <div class="d-flex justify-content-between cursor-pointer px-3 pb-1"
                        @click="accountableRow.item.showProperty = !accountableRow.item.showProperty"
                        :class="{ 'mb-2 border-bottom': accountableRow.item.showProperty }">
                        <div>
                            <div class="d-flex gap-1">
                                <span class="text-warning font-size-17">{{ accountableRow.item.accountableOfficer
                                    }}</span>
                                <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm"
                                    toggle-class="text-decoration-none" menu-class="dropdown-menu" no-caret>
                                    <template #button-content>
                                        <i class="bx bx-printer me-1"></i>
                                        Print ICF
                                    </template>
                                    <b-dropdown-item
                                        @click.stop="$emit('print-icf', { item: accountableRow.item, type: 'low' })">
                                        <i class="mdi mdi-arrow-down me-1"></i>Low Value
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        @click.stop="$emit('print-icf', { item: accountableRow.item, type: 'high' })">
                                        <i class="mdi mdi-arrow-up me-1"></i>High Value
                                    </b-dropdown-item>
                                </b-dropdown>
                                <button class="btn btn-purple btn-sm"
                                    @click.stop="$emit('print-certificate', accountableRow.item)"><i
                                        class="bx bx-printer me-1"></i>Print Certificate</button>
                            </div>
                            <div class="form-check form-checkbox-outline form-check-success mb-0"
                                v-if="accountableRow.item.employeeIdNumber" @click.stop>
                                <input type="checkbox" :id="`customCheckcolor2-${accountableRow.index}`"
                                    checked="checked" class="form-check-input" v-model="accountableRow.item.isPresent"
                                    @click.stop="changeAvailableness(accountableRow.item, $event)" />
                                <label :for="`customCheckcolor2-${accountableRow.index}`" class="form-check-label"
                                    @click.stop>
                                    Present
                                </label>
                            </div>
                        </div>
                        <span v-if="!accountableRow.item.showProperty">Show {{ accountableRow.item.count }}
                            properties</span>
                    </div>
                    <b-collapse :visible="accountableRow.item.showProperty" role="tabpanel">
                        <div v-if="accountableRow.item.showProperty">
                            <InventoryCardList :filter="itemData.filter" :accountableRow="accountableRow"
                                :assignmentHistoryEmployeeData="assignmentHistoryEmployeeData"
                                :assignmentHistoryLocationData="assignmentHistoryLocationData" :viewFrom="viewFrom"
                                @changePropertyStatus="changePropertyStatus" @changeBookedStatus="changeBookedStatus"
                                @printParProperty="$emit('printParProperty', $event)"
                                @printIcsProperty="$emit('printIcsProperty', $event)"
                                @printStickerProperty="$emit('printStickerProperty', $event)"
                                @printPropertyCard="$emit('printPropertyCard', $event)"
                                @updateItem="$emit('updateItem', $event)" @deleteItem="$emit('deleteItem', $event)"
                                @getEmployee="$emit('getEmployee', $event)" @getLocation="$emit('getLocation', $event)"
                                @checkToggle="checkToggle" />
                        </div>
                    </b-collapse>
                </div>
            </template>
        </b-table>
        <div class="row">
            <div v-if="propertyRows > 0" class="col">
                Showing
                {{ (itemData.currentPage - 1) * itemData.perPage + 1 }} -
                {{
                    propertyRows > (itemData.currentPage - 1) *
                        itemData.perPage + itemData.perPage ?
                        (itemData.currentPage - 1) * itemData.perPage +
                        itemData.perPage
                        : propertyRows
                }}
                of {{ propertyRows }}
            </div>
            <div class="col">
                <div @click="resetToggle(itemData)" class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                        <b-pagination v-model="itemData.currentPage" :total-rows="propertyRows"
                            :per-page="itemData.perPage"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>